import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { SidebarChildItem, SidebarMenuItem } from './sidebarMenu';


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarMenuItem',
  props: {
    item: null,
    expanded: { type: Boolean },
    collapsed: { type: Boolean },
    activeRoute: null
  },
  emits: ["toggle", "navigate"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'toggle', name: string): void;
    (e: 'navigate', item: SidebarMenuItem | SidebarChildItem): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    item: SidebarMenuItem;
    expanded: boolean;
    collapsed: boolean;
    activeRoute?: string;
};





const hasChildren = computed(() => !!props.item.children?.length);
const visibleChildren = computed(() => props.item.children?.filter((child) => !child.hidden) ?? []);

const onItemClick = () => {
    if (hasChildren.value) {
        emit('toggle', props.item.name);
        return;
    }
    emit('navigate', props.item);
};

return { __sfc: true,props, emit, hasChildren, visibleChildren, onItemClick }
}

})